import { useDispatch } from "react-redux";
import "./../App.css"
import { addUserAction, clearUserAction } from "../Redux/userReducer";
import { userFetch } from "../Thunk/userThunk";

const User = () => {

    const dispatch = useDispatch();

    const addUser = (name) => {
        const user = {
            name,
            id: Date.now(),
        }
        dispatch(addUserAction(user))
    }

    return (
        <div className="btn">
            <button onClick={() => addUser(prompt())}>Add user</button>
            <button onClick={() => dispatch(clearUserAction())}>Clean</button>
            <button onClick={() => dispatch(userFetch())}>Fetch users</button>
        </div>
    )
}


export default User;